import ConsignmentStatusBadge from '@components/ConsignmentStatusChip';
import Flex from '@ds/components/layout/Flex';
import Typography from '@ds/components/typography/Typography';
import React from 'react';

import NavItem from '../NavItem';

interface Props {
    consignment: {
        status: string;
        number: string;
        updatedAt?: string;
    };
    currentPath: string;
    onBack: () => void;
}

const stringToRelativeTime = (str?: string) => (str && new Date(str)?.relativeTime()) || 'never';

const Desktop: React.FC<Props> = ({ consignment, onBack, currentPath }) => (
    <Flex
        direction="row"
        align="center"
        data-cy="menu-header"
        gap={6}
    >
        <NavItem
            type="internal"
            title="Back to consignments"
            path="/consignments"
            internal={{ isActive: currentPath.startsWith('/consignments') }}
            preAction={onBack}
        />
        <>
            <ConsignmentStatusBadge
                status={consignment.status}
                data-cy="menu-header-consignment-status"
            />
            <>
                <Typography
                    variant="body-2"
                    data-cy="menu-header-consignment-number"
                    color="secondary-1"
                >
                    Consignment&nbsp;
                    <Typography
                        variant="body-2"
                        weight="semibold"
                        color="secondary-1"
                        component="span"
                    >
                        {consignment.number}
                    </Typography>
                </Typography>
            </>
            <>
                <Typography
                    variant="body-2"
                    color="secondary-1"
                >
                    Updated&nbsp;
                    <Typography
                        variant="body-2"
                        color="secondary-1"
                        component="span"
                        weight="semibold"
                    >
                        {stringToRelativeTime(consignment.updatedAt)}
                    </Typography>
                </Typography>
            </>
        </>
    </Flex>
);

export default Desktop;
